// extracted by mini-css-extract-plugin
module.exports = {"dots":"FadingDots_dots__3UgT6","fade":"FadingDots_fade__3IMLw"};